import { Component, Vue } from "vue-property-decorator";

import template from "./foot.vue";

/**
 * Footer
 */
@Component({
  mixins: [template],
})
export default class Foot extends Vue {
  /**
   * Verson de l'application
   * @type {string}
   */
  protected version: string = `${process.env.VUE_APP_VERSION}`;
}
